module.exports = __webpack_public_path__ + "img/jobscloud_logo@2x.9baa7a67.png";